import { render, staticRenderFns } from "./ElementSwitchSetting.vue?vue&type=template&id=344058c7&scoped=true"
import script from "./ElementSwitchSetting.vue?vue&type=script&lang=js"
export * from "./ElementSwitchSetting.vue?vue&type=script&lang=js"
import style0 from "./ElementSwitchSetting.vue?vue&type=style&index=0&id=344058c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344058c7",
  null
  
)

export default component.exports